
import React, { useState, useEffect } from "react";
import "../../../style/styles.css";
import ItemSection from "../../../components/home/ItemsSection/ItemSection";
import AutoSlidingItemSection from "../../../components/home/ItemsSection/AutoSlidingItemSection";
import StorySection from "../../../components/home/StorySection/StorySection";
import CollectionSlider from "../../../components/home/CollectionSlider/CollectionSlider";
import HeroSection from "../../../components/home/HeroSection/HeroSection";
import StructuredData from "../../../components/common/StructuredData/StructuredData";
import { useDynamicPageTitle } from "../../../hooks/useDynamicPageTitle";
import { DEFAULT_STORE_ID } from "../../../firebase/firebase";
import { getUserStoreProducts } from "../../../firebase/product-functions";


export default function HomePage() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  // Set dynamic page title using store settings
  useDynamicPageTitle('home');

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const storeId = DEFAULT_STORE_ID;
        const cacheKey = `homeProducts_${storeId}`;
        const cachedProducts = sessionStorage.getItem(cacheKey);
        const cacheTimestamp = sessionStorage.getItem(`${cacheKey}_timestamp`);

        // Use cache if it's less than 3 minutes old
        if (cachedProducts && cacheTimestamp) {
          const age = Date.now() - parseInt(cacheTimestamp);
          if (age < 3 * 60 * 1000) {
            const parsedProducts = JSON.parse(cachedProducts);
            setProducts(parsedProducts);
            setLoading(false);
            return;
          }
        }

        // Fetch products
        const result = await getUserStoreProducts(storeId, {
          limit: 8,
          status: "active",
          sortBy: "createdAt",
          sortDirection: "asc",
        });

        const productsData = result.products.map((product) => {
          const image =
            product.images && product.images.length > 0
              ? product.images[0]
              : "https://via.placeholder.com/300x300?text=No+Image";

          let isOutOfStock = false;
          if (product.status?.toLowerCase() === "out-of-stock") {
            isOutOfStock = true;
          } else if (product.variants && product.variants.length > 0) {
            isOutOfStock = product.variants.every(
              (v) => parseInt(v.quantity) !== -1 && v.quantity <= 0
            );
          } else {
            isOutOfStock =
              parseInt(product.quantity) !== -1 && product.quantity <= 0;
          }

          return {
            ...product,
            storeId: storeId,
            image,
            isOutOfStock,
          };
        });

        setProducts(productsData);

        // Cache the products
        sessionStorage.setItem(cacheKey, JSON.stringify(productsData));
        sessionStorage.setItem(`${cacheKey}_timestamp`, Date.now().toString());
      } catch (err) {
        console.error("Error fetching products:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  return (
    <div className="homepage">
      <StructuredData pageType="home" />
      <HeroSection />

      <CollectionSlider />
      <ItemSection products={products} loading={loading} />
      <StorySection />
    </div>
  );
}
